import { compose } from 'redux'

// higher-order components
import withRedux from './withRedux'
import withMutation from './withMutation'
import withEventHandlers from './withEventHandlers'

// presentational component
import UI from './UI'

export default compose(
  withRedux, // for setting error and modal states
  withMutation, // for deleting file
  withEventHandlers // for modal interactions
)(UI)
